import backend from './backend';
import soa from './soa';

export type APIStatus = 'NOT_ASKED' | 'LOADING' | 'SUCCESS' | 'FAILURE';

export default { backend, soa };
